import { render, staticRenderFns } from "./roleConfigCard.vue?vue&type=template&id=381d1552&scoped=true"
import script from "./roleConfigCard.vue?vue&type=script&lang=js"
export * from "./roleConfigCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d1552",
  null
  
)

export default component.exports